import { QueryState } from '@/components/layout/query-state';
import { ScreenHeader } from '@/components/layout/screen-header';
import { PageTitle } from '@/components/seo/page-title';
import { ProfileScreen } from '@/features/profile/profile-screen';
import { useProfileByIdentifier } from '@/features/profile/hooks/use-profile-by-identifier';
import { useAuth } from '@/hooks/use-auth';
import { useLocalSearchParams } from 'expo-router';
import React from 'react';
import { ScrollView, View } from 'react-native';

export default function ProfileRoute() {
  const { username } = useLocalSearchParams<{ username: string }>();
  const { user: currentUser } = useAuth();
  const { profileData, isLoading, error, refetch } = useProfileByIdentifier(username);

  const isCurrentUser = profileData?.user?.id === currentUser?.id;

  return (
    <QueryState
      isLoading={isLoading}
      error={error}
      onRetry={() => refetch()}
      loadingMessage="Loading profile..."
      fullScreen={false}
    >
      {profileData?.user ? (
        <View className="flex-1">
          <PageTitle title={profileData.user.name || 'Profile'} />
          <ScreenHeader title="Profile" showBackButton />
          <ScrollView
            showsVerticalScrollIndicator={false}
            className="flex-1"
          >
            <ProfileScreen
              user={profileData.user}
              isCurrentUser={isCurrentUser}
            />
          </ScrollView>
        </View>
      ) : null}
    </QueryState>
  );
}
